<script setup>
import AppHeader from '@/components/App/Header.vue'
import AppFooter from '@/components/App/Footer.vue'
import Betslips from '@/components/Betslips.vue';
import Spinner from '@/components/Spinner.vue';
import AppNavigation from '@/components/App/Navigation.vue'
import TermsModal from '@/views/(app)/Partials/TermsModal.vue';
import AppWarning from '@/views/(app)/Partials/AppWarning.vue';

import { useAuthStore } from '@/stores/auth';
import { useLiveStore } from '@/stores/live';
import { useChatStore } from '@/stores/chat';
import { useGamesStore } from '@/stores/games';
import { useFixturesStore } from '@/stores/fixtures';
import { storeToRefs } from 'pinia';
import { socket } from '@/user.socket';
import { socket as feedSocket } from '@/feed.socket';
import { onMounted, ref } from 'vue';
import { useJackpotStore } from '@/stores/jackpot';


const liveStore = useLiveStore()
const authStore = useAuthStore()
const chat = useChatStore()
const gamesStore = useGamesStore()
const fixtures = useFixturesStore()
const jackpotStore = useJackpotStore()

const { isAuth, getUser, getNotices } = storeToRefs(authStore)
const { getIsGameFullscreen } = storeToRefs(gamesStore)
const { hasFixtures } = storeToRefs(fixtures)
const termsRef = ref(null);

onMounted(async () => {
  socket.connect();
  feedSocket.connect();
  liveStore.bindSocketEvents();
  if (isAuth.value) {
    Promise.all([
      authStore.fetchNotices(),
      authStore.fetchUserMarketTemplate(),
      authStore.fetchJackpotTiers()
    ]).then(() => {
      authStore.bindSocketEvents();
      jackpotStore.bindSocketJackpots()
      chat.bindSocketMessages();
      if(getUser.value.acc_term == false){
          termsRef.value.openModal();
      }
    })
  }else{
    authStore.fetchDefaultJackpotTiers()
  }
})
</script>

<template>
  <div class="h-screen flex flex-col overflow-hidden">
    <AppHeader v-if="!getIsGameFullscreen" />
    <main class="pageView w-full flex-1 overflow-auto" data-scroll-root>
      <AppWarning v-if="getNotices.length" :data="getNotices"/>
        <RouterView v-if="hasFixtures " />
      <AppFooter />
    </main>
    <AppNavigation v-if="!getIsGameFullscreen" class="block lg:hidden fixed bottom-0 w-full z-50"/>

    <Betslips v-if="hasFixtures" />
    <Spinner :show="!hasFixtures" />
    <TermsModal ref="termsRef" v-if="isAuth" />
  </div>
</template>
